import React from "react";
import { Button } from "@material-ui/core";
import { Add } from "@material-ui/icons";
import MaterialTable from "material-table";

export default function TableDetail({ data, onCrudGK }: any) {
  return (
    <>
      <Button
        onClick={() =>
          onCrudGK({
            action: "Add",
            title: data.title_id,
            data: { id_type: data.id, imagesRead: [], images: [] },
          })
        }
        variant="contained"
        size="small"
        startIcon={<Add />}
      >
        Add {data.title_id}
      </Button>
      <MaterialTable
        columns={[
          { title: "No.", field: "no" },
          { title: "Company", field: "company" },
          { title: "Link", field: "link" },
        ]}
        data={() =>
          new Promise((resolve) => {
            fetch(
              `${process.env.REACT_APP_URL}/api/jlp/content/gk/${data.id}`
            ).then(async (result: any) => {
              const resJson = await result.json();
              resolve({
                data: resJson.data,
                page: 0,
                totalCount: resJson.data.length,
              });
            });
          })
        }
        options={{
          paging: false,
          sorting: false,
          search: false,
          showTitle: false,
          toolbar: false,
        }}
        style={{ boxShadow: "none", marginTop: 8, marginBottom: 32 }}
        onRowClick={(event, rowData: any) => {
          onCrudGK({
            action: "Edit",
            title: rowData.title_id,
            data: {
              id: rowData.id,
              id_type: rowData.id_type,
              company: rowData.company,
              link: rowData.link,
              no: rowData.no,
            },
          });
        }}
      />
    </>
  );
}
